module.exports = __webpack_public_path__ + "static/media/colored-pencils.24af2941.jpg";